import React, { useState } from "react";
import { Edit, Download, MessageSquare, X } from "lucide-react";
import { formatReadableDate } from "../../../utils/utils";
import {
  FaLinkedin,
  FaInstagram,
  FaFacebook,
  FaWhatsapp,
} from "react-icons/fa";

const ProfileHeader = ({
  staffData,
  getDisplayProfilePicUrl,
  roleMapping,
  onEditProfile,
  onExportData,
  onAssignTask,
}) => {
  const [isImageOpen, setIsImageOpen] = useState(false);
  console.log(staffData, "kkkkkllllll");
  if (!staffData?.data) return null;

  const {
    name,
    staffId,
    email,
    phone,
    location,
    pincode,
    age,
    createdAt,
    role,
    profilePicture,
    performanceRating,

    // ✅ Branch fields
    branchName,
    targetLoans,
    status,
    branchType,
    branchLocation,
  } = staffData.data;

  console.log(staffData.data, "kkkkkllllll");
  return (
    <div className="bg-[#131313] rounded-lg p-4 mb-6 text-white">
      {/* Top Section */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          {/* Profile Picture */}
          <div
            className="w-16 h-16 rounded-full bg-gray-700 overflow-hidden cursor-pointer hover:scale-105 transition"
            onClick={() => setIsImageOpen(true)}
          >
            <img
              src={getDisplayProfilePicUrl(profilePicture)}
              alt={name || "Staff"}
              className="w-full h-full object-cover"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = getDisplayProfilePicUrl(null);
              }}
            />
          </div>

          <div>
            <div className="flex flex-col sm:flex-row sm:items-center gap-2">
              <h2 className="text-xl font-bold capitalize">{name}</h2>
              {/* <span className="text-[#FFCA20] text-sm font-medium">
                {performanceRating || "90"}% Performance Rating
              </span> */}
              {/* Social Media Icons */}
              <div className="flex gap-4 ml-2">
                {staffData.data.socialMedia?.linkedin && (
                  <a
                    href={staffData.data.socialMedia.linkedin}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaLinkedin
                      size={30}
                      className="text-[#0e76a8] hover:scale-110 transition"
                    />
                  </a>
                )}
                {staffData.data.socialMedia?.instagram && (
                  <a
                    href={staffData.data.socialMedia.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaInstagram
                      size={30}
                      className="text-pink-500 hover:scale-110 transition"
                    />
                  </a>
                )}
                {staffData.data.socialMedia?.facebook && (
                  <a
                    href={staffData.data.socialMedia.facebook}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaFacebook
                      size={30}
                      className="text-[#1877F2] hover:scale-110 transition"
                    />
                  </a>
                )}
                {staffData.data.socialMedia?.whatsapp && (
                  <a
                    href={`https://wa.me/${staffData.data.socialMedia.whatsapp}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FaWhatsapp
                      size={30}
                      className="text-[#25D366] hover:scale-110 transition"
                    />
                  </a>
                )}
              </div>
            </div>
            <div className="text-sm text-gray-400">STAFF ID {staffId}</div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-wrap gap-2 w-full md:w-auto">
          {/* Task Button */}
          <div className="w-full lg:w-auto flex justify-start lg:justify-end">
            <button
              onClick={onAssignTask}
              className="mt-2 lg:mt-0 px-4 py-2 w-full lg:w-auto bg-[#FFCA20] text-black rounded flex items-center gap-2 justify-center hover:bg-[#FFCA20] hover:text-black transition"
            >
              <MessageSquare size={16} />
              Assign task
            </button>
          </div>
          <button
            onClick={onEditProfile}
            className="mt-2 lg:mt-0 px-4 py-2 w-full lg:w-auto bg-[#FFCA20] text-black rounded flex items-center gap-2 justify-center hover:bg-[#FFCA20] hover:text-black transition"
          >
            <Edit size={16} />
            Edit Profile
          </button>
          <button
            onClick={onExportData}
            className="mt-2 lg:mt-0 px-4 py-2 w-full lg:w-auto bg-[#FFCA20] text-black rounded flex items-center gap-2 justify-center hover:bg-[#FFCA20] hover:text-black transition"
          >
            <Download size={16} />
            Export Data
          </button>
        </div>
      </div>

      {/* Detail Info & Task Button */}
      <div className="flex flex-col lg:flex-row justify-between items-start lg:items-center mt-4 gap-4">
        <div className="grid grid-cols-1 lg:flex lg:flex-wrap gap-6 flex-1">
          <div className="lg:pr-4 lg:border-r-2 lg:border-[#333333]">
            <div className="text-xs text-gray-400">Role</div>
            <div>{roleMapping[role] || role}</div>
          </div>
          <div className="lg:pr-4 lg:border-r-2 lg:border-[#333333]">
            <div className="text-xs text-gray-400">Contact Number</div>
            <div>{phone}</div>
          </div>
          <div className="lg:pr-4 lg:border-r-2 lg:border-[#333333]">
            <div className="text-xs text-gray-400">Email ID</div>
            <div>{email}</div>
          </div>
          <div className="lg:pr-4 lg:border-r-2 lg:border-[#333333]">
            <div className="text-xs text-gray-400">Date of Joining</div>
            <div>{formatReadableDate(createdAt)}</div>
          </div>
          <div className="lg:pr-4 lg:border-r-2 lg:border-[#333333]">
            <div className="text-xs text-gray-400">Location</div>
            <div>{location}</div>
          </div>
          <div className="lg:pr-4 lg:border-r-2 lg:border-[#333333]">
            <div className="text-xs text-gray-400">PIN Code</div>
            <div>{pincode}</div>
          </div>
          <div className="lg:pr-4">
            <div className="text-xs text-gray-400">Age</div>
            <div>{age}</div>
          </div>
          {/* ✅ TargetLoans */}
          <div className="w-full">
            <h3 className="text-sm font-semibold text-[#FFCA20]">
              Montly No Of TargetLoans & Status
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <div className="text-xs text-gray-400">Target Loans</div>
                <div>{targetLoans}</div>
              </div>
              <div>
                <div className="text-xs text-gray-400 mb-1">Status</div>
                <div
                  className={`
          ${
            status?.toLowerCase() === "active"
              ? "bg-green-500 bg-opacity-20 text-green-500"
              : status?.toLowerCase() === "pending"
              ? "bg-orange-500 bg-opacity-20 text-orange-500"
              : "bg-[#FFCA20] bg-opacity-20 text-[#FFCA20]"
          } inline-block px-3 py-0.5 rounded-full text-sm font-medium
        `}
                >
                  {status}
                </div>
              </div>
            </div>
          </div>

          {/* ✅ Branch Details */}
          <div className="w-full ">
            <h3 className="text-sm font-semibold text-[#FFCA20] mb-2">
              Branch Details
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <div className="text-xs text-gray-400">Branch Name</div>
                <div>{branchName}</div>
              </div>
              <div>
                <div className="text-xs text-gray-400">Branch Type</div>
                <div>
                  {branchType === "district"
                    ? "District Level"
                    : branchType === "mandal"
                    ? "Mandal Level"
                    : branchType === "village"
                    ? "Village Level"
                    : branchType}
                </div>
              </div>
              <div>
                <div className="text-xs text-gray-400">Branch Location</div>
                <div>{branchLocation}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* 50% Modal Image */}
      {isImageOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
          <div className="relative w-1/2 max-h-[80%] p-4">
            <button
              onClick={() => setIsImageOpen(false)}
              className="absolute top-2 right-2 text-white hover:text-gray-400"
            >
              <X size={28} />
            </button>
            <img
              src={getDisplayProfilePicUrl(profilePicture)}
              alt={name || "Staff"}
              className="w-full h-auto max-h-[50vh] rounded-lg shadow-lg object-contain"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = getDisplayProfilePicUrl(null);
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ProfileHeader;
